var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import styled from 'styled-components';
import WindowEventContext from '../../context/window-event-context';
import { getGeometryStyle } from '../../helpers/styles';
import useFormItem from '../../hooks/useFormItem';
import Image from '../Image';
var StyledImageToggleButton = styled.button.attrs(function (props) { return ({
    className: props.type,
}); })(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  background: inherit;\n  cursor: pointer;\n"], ["\n  ", "\n  background: inherit;\n  cursor: pointer;\n"])), function (_a) {
    var geometry = _a.geometry;
    return getGeometryStyle(geometry);
});
var ImageToggleButton = function (props) {
    var identifier = props.identifier, type = props.type, restProps = __rest(props, ["identifier", "type"]);
    var _a = useFormItem(identifier).value, value = _a === void 0 ? false : _a;
    var _onToggleButtonClick = useContext(WindowEventContext)._onToggleButtonClick;
    var geometry = props.attributes.geometry;
    var iconSize = props.attributes.iconSize;
    var _b = props.attributes.icon, normalon = _b.normalon, normaloff = _b.normaloff;
    return (React.createElement(StyledImageToggleButton, __assign({ id: identifier, "data-widget-type": type, geometry: geometry, onClick: function (evt) {
            _onToggleButtonClick(identifier, !value);
        } }, restProps),
        React.createElement(Image, { width: iconSize.width, height: iconSize.height, imageName: value ? normalon : normaloff })));
};
export default ImageToggleButton;
var templateObject_1;
//# sourceMappingURL=index.js.map